import { InjectionToken } from '@angular/core';
import { UsersnapConfig } from '../model/usersnap-config';

/**
 * Provides a token to override default config
 */
export const US_CONFIG = new InjectionToken<UsersnapConfig>('us-config');
